import { initializeApp } from 'firebase/app'
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyA9iw0bgAC1sxBOv-H6NihQcIbiTY0_BQM",
  authDomain: "ouderraad-loppem.firebaseapp.com",
  projectId: "ouderraad-loppem",
  storageBucket: "ouderraad-loppem.firebasestorage.app",
  messagingSenderId: "158496735060",
  appId: "1:158496735060:web:92fcf0681ccfdae3f5d2c1",
  measurementId: "G-BR3VYJDKED"
};
const firebaseApp = initializeApp(firebaseConfig);
const remoteConfig = getRemoteConfig(firebaseApp);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
remoteConfig.defaultConfig = {"config": false};

const auth = getAuth();
export function firebaseListener(func) {
    auth.onAuthStateChanged(function(user) {
    if (user) {
       console.log("User log in success", user);
      func(true, user)
    } else {
      console.log("User log in failed", user);
      func(false)
    }
  }, function(error) {
    console.log(error)
  });
}
export const db = getFirestore(firebaseApp);
export const firebaseAuth = getAuth();
export const rmc = remoteConfig;